import { ActionIcon, Menu } from '@mantine/core';
// icons
import { CircleX, EllipsisVertical } from 'lucide-react';

interface BillingMenuProps {
    onCancel: () => void;
}

const BillingMenu = ({ onCancel }: BillingMenuProps) => {
    return (
        <Menu shadow="md" width={200}>
            <Menu.Target>
                <ActionIcon variant="transparent">
                    <EllipsisVertical />
                </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Item
                    color="red"
                    leftSection={<CircleX />}
                    onClick={onCancel}
                >
                    Cancel Subscription
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};

export default BillingMenu;
